export default {
  date: {
    y: "years",
    m: "months",
    d: "days",
  },

  time: {
    h: "hours",
    min: "minutes",
    s: "second",
    ago: "ago",
    present: "present",
    justNow: "just now",
  },

  // no data
  noData: "No data",

  //not specified
  notSpecified: "Not Specified",

  //check document
  checkDocs: {
    code_0: "Digital signatures and XML are not trusted.",
    code_1: "Digital signatures are reliable, but XML is not.",
    code_2: "Digital signatures and XML are reliable.",
  },
};
